import { createContext, useContext } from 'react'
import type { WireArtifact } from '../../../api/types'

const ArticleArtifactsContext = createContext<WireArtifact[]>([])

export function useArticleArtifacts(): WireArtifact[] {
  return useContext(ArticleArtifactsContext)
}

export { ArticleArtifactsContext }
